<template>
  <K2Modal :fullscreen="false" :dialog="modal==='preview'" @handleClose="$emit('handleClose')"
           @onConfirm="$emit('onConfirm')" :hideFooter="true" :hideHeader="true" v-if="parentPost">
    <K2Row justify_content="center" class="position-relative previewHeader" align="center" space-between="true">
      <K2Icon color="black" name="chevron_left" @onclick="$emit('handleClose')" link="true"
              style="top:0"/>
      <K2Heading type="h5" class-name="mb-0" color="black">
        {{postCategory}}
        {{parentPost.PostUpdDtlTitle||lang("Preview Post")}}
      </K2Heading>
      <div>
        <K2Row v-if="approverPostNotShow && post.PostCreatedBy === feedUserID">
          <K2Confirm :title="lang('Are you sure you want to delete this post?')" noChildren="true"
                     theme="1" @confirm="$emit('deletePost', parentPost)"
                     :background="uiVariable.color.backgroundGrey"
                     :label="lang('Delete')" color="white"/>
          <!--            <K2Button size="small" :background="uiVariable.color.backgroundGrey" @onclick="deletePost(previewPost)">Delete</K2Button>-->
          <K2Button size="small" @onclick="$emit('handleUpdates')">{{ lang("Edit") }}</K2Button>
        </K2Row>
      </div>
    </K2Row>
    <div id="preview" class="m-2 m-md-4 py-2 preview">
        <div class="mb-3" :style="[allStudentShow?{maxHeight:'none'}:{maxHeight:'133px'},{overflow:'hidden'}]">
            <K2Row :space-between="true" :styles="{width:'100%'}">
                <K2Text bold="true">{{lang("Showing To")}}</K2Text>
                <K2Button size="mini" v-if="allStudentShow" @onclick="handleStudentShow()">{{lang("Show Less")}}
                </K2Button>
                <K2Button size="mini" v-else-if="selectedStudents && selectedStudents.length >5"
                          @onclick="handleStudentShow()">{{lang("Show All")}}
                </K2Button>
            </K2Row>
            <K2Row v-if="passSchool">
                <K2Row justify_content="center" align="center"
                       class=" box error me-2 mt-2 rounded-pill px-3 px-md-2  py-1"
                       v-if="passSchool">
                    <K2Text color="white">{{ passSchool }}</K2Text>
                </K2Row>
            </K2Row>
            <K2Row class="flex-wrap" v-else-if="levelList && levelList.length >0"
                   :styles="{flexWrap:'wrap'}">
                <K2Row justify_content="center" align="center" v-for="(level,i) in levelList" :key="i"
                       class=" box blue me-2 mt-2 rounded-pill px-3 px-md-2  py-1">
                    <K2Text color="white">{{ level.Str_Display || level.PostTagLevelName }}</K2Text>
                </K2Row>
            </K2Row>
            <K2Row v-else-if="classList && classList.length >0" :styles="{flexWrap:'wrap'}">
                <K2Row justify_content="center" align="center" v-for="(classes,i) in classList" :key="i"
                       class=" box yellow me-2 mt-2 rounded-pill  px-3 px-md-2  py-1">
                    <K2Text>{{ classes.Str_Display || classes.PostTagClassName }} {{classes.PostTagClassBatch}}</K2Text>
                </K2Row>
            </K2Row>
            <K2Row v-else-if="selectedStudents && selectedStudents.length >0" :styles="{flexWrap:'wrap'}">
                <K2Row v-if="selectedStudents[0].CLS_ClassName">

                    <K2Row v-for="(studentClass) in selectedStudents" :key="studentClass.CLS_ClassName"
                           :styles="{flexWrap:'wrap'}">

                      <div v-if="selectedStudents[0].itemList">
                        <K2Row justify_content="center" align="center" v-for="(student,i) in studentClass.itemList"

                               :key="student.PostTagUserID+i"
                               class=" box purple me-2 mt-2 rounded-pill  px-3 px-md-2  py-1">
                          <K2Text :color="uiVariable.color.purple" class="me-2">{{ studentClass.CLS_ClassName }} :
                          </K2Text>
                          <K2Text :color="uiVariable.color.purple"> {{ student.StudentName || student.First_Name }}
                          </K2Text>
                        </K2Row>
                      </div>
                        <K2Row justify_content="center" align="center" v-for="(student,i) in selectedStudents"
                               v-else
                               :key="student.PostTagUserID+i"
                               class=" box purple me-2 mt-2 rounded-pill  px-3 px-md-2  py-1">
                            <K2Text :color="uiVariable.color.purple">{{ student.StudentName || student.First_Name }}
                            </K2Text>
                        </K2Row>
                    </K2Row>
                </K2Row>
                <div v-else>
                    <K2Row :styles="{flexWrap:'wrap'}">
                        <K2Row justify_content="center" align="center" v-for="(student) in selectedStudents"
                               :key="student.PostTagUserID"
                               class=" box purple me-2 mb-2 rounded-pill  px-3 px-md-2  py-1">
                            <K2Text :color="uiVariable.color.purple" class="me-2">{{ student.StudentClassName }} :
                            </K2Text>
                            <K2Text :color="uiVariable.color.purple"> {{ student.StudentName || student.First_Name }}
                            </K2Text>
                        </K2Row>
                    </K2Row>
                </div>
            </K2Row>
        </div>
        <div v-if="isMomentPost">
            <K2Text bold="true">{{lang("Student Information")}}:</K2Text>
            <K2Row style="flex-wrap: wrap" class="mt-2 mb-3" v-if="selectedStudents&&selectedStudents.length">
                <div class="newPostSetting__info">
                    <span class="k2Tag">Name</span>
                    {{selectedStudents[0].StudentName||(selectedStudents[0].itemList ? selectedStudents[0].itemList[0].First_Name : "")}}
                    <span class="k2Tag">Class</span>
                    {{selectedStudents[0].StudentClassName||(selectedStudents[0].itemList ? selectedStudents[0].itemList[0].ClassFullName : "")}}
                    <span class="k2Tag">Age</span>
                  {{selectedStudents[0].age||(selectedStudents[0].itemList ? selectedStudents[0].itemList[0].age : "")}}
                </div>
            </K2Row>
        </div>

      <K2Carousel :slide-list="parentPost.postFiles" v-if="parentPost.postFiles && parentPost.postFiles.length"/>

        <div class="my-3">
            <div v-if="isBroadcastPost">
              <div v-if="parentPost && parentPost.PostUpdDtlContent1 !== 'null'">
                <K2Text bold="true">{{lang("Content")}}:</K2Text><br/>
                <span v-html="(parentPost.PostUpdDtlContent1)"/>
              </div>
              <div v-else-if="state && state.content">
                <K2Text bold="true">{{lang("Content")}}:</K2Text><br/>
                <span v-html="(state&&state.content)"/>
              </div>
            </div>
            <div v-else>
                <div v-if="(state&&state.content)||(parentPost && parentPost.PostUpdDtlContent1)">
                    <K2Text bold="true">
                        {{feedItemConfig&&feedItemConfig.contentLabel||layoutConfig&&layoutConfig.contentLabel||lang("Content")}}:
                    </K2Text>
                    <br/>
                    <span v-html="(state&&state.content)||(parentPost && parentPost.PostUpdDtlContent1)"/>
                </div>
                <ActivityPreviewGoal v-if="isNewsfeed"
                                     :passdevelopmentgoals="parentPost.PostLearningMoments" :post-type="parentPost.PostType"
                                     :is-published="isPublished" :isMomentPost="isMomentPost"
                                     :parent-post="parentPost"/>
                <div v-if="(state&&checkContent(state.content2))||(parentPost && checkContent(parentPost.PostUpdDtlContent2))">
                    <K2Text bold="true">
                        {{feedItemConfig&&feedItemConfig.content2Label||layoutConfig&&layoutConfig.content2Label||lang("Content")}}:
                    </K2Text>
                    <br/>
                    <span v-html="(state&&state.content2)||(parentPost && parentPost.PostUpdDtlContent2)"/>
                </div>
                <div v-if="!isMomentPost">
                    <div v-if="(state&&checkContent(state.content3))||(parentPost && checkContent(parentPost.PostUpdDtlContent3))">
                        <K2Text bold="true">
                            {{feedItemConfig&&feedItemConfig.content3Label||layoutConfig&&layoutConfig.content3Label||lang("Content")}}:
                        </K2Text>
                        <br/>
                        <span v-html="state&&state.content3||(parentPost && parentPost.PostUpdDtlContent3) "/>
                    </div>
                    <div v-if="(state&&checkContent(state.content4))||(parentPost && checkContent(parentPost.PostUpdDtlContent4))">
                        <K2Text bold="true">
                            {{feedItemConfig&&feedItemConfig.content4Label||layoutConfig&&layoutConfig.content4Label||lang("Content")}}:
                        </K2Text>
                        <br/>
                        <span v-html="(state&&state.content4)||(parentPost && parentPost.PostUpdDtlContent4)"/>
                    </div>
                </div>
                <ActivityPreviewGoal v-if="isMomentPost" :passdevelopmentgoals="parentPost.PostLearningMoments" :post-type="parentPost.PostType"
                                     :is-published="isPublished" :isMomentPost="isMomentPost"
                                     :parent-post="parentPost"/>
            </div>


            <!--<div v-if="passObservation||parentPost">-->
            <!--<K2Text bold="true">{{lang("Observation")}}:</K2Text>-->
            <!--<br/>-->
            <!--<span v-html="passObservation||parentPost.PostUpdDtlObservation"/>-->
            <!--</div>-->
            <div class="mb-3" v-if="parentPost.PostKeyTags && parentPost.PostKeyTags.length>0">
                <K2Text bold="true">{{lang("Tags")}}:</K2Text>
                <K2Row class="flex-wrap" v-if="isPublished">
                    <K2Row justify_content="center" align="center" v-for="(tag) in parentPost.PostKeyTags"
                           :key="tag.PostKeyTagPostID + tag.PostKeyTagValue"
                           class=" box purple me-2 mt-2 rounded-pill px-2 py-1">
                        <K2Text :color="uiVariable.color.purple">{{ tag.PostKeyTagValue }}</K2Text>
                    </K2Row>
                </K2Row>
                <K2Row class="flex-wrap" v-else>
                    <K2Row justify_content="center" align="center" v-for="(tag) in parentPost.PostKeyTags"
                           :key="tag.KeyTag"
                           class=" box purple me-2 mt-2 rounded-pill px-2 py-1">
                        <K2Text :color="uiVariable.color.purple">{{ tag.KeyTag }}</K2Text>
                    </K2Row>
                </K2Row>
            </div>

            <K2Row>
                <div class="me-2">
                    <K2Text bold="true" v-if="parentPost && parentPost.PostIsUpdated">{{lang("Modified on")}}:</K2Text>
                    <K2Text bold="true" v-else>{{lang("Created On")}}:</K2Text>
                    <K2Text :color="uiVariable.color.purple" v-if="isPublished">
                        {{ moment(parentPost.PostCreatedDate).format("DD/MM/YYYY [&nbsp;] HH:mm") }}
                    </K2Text>
                    <K2Text :color="uiVariable.color.purple" v-else>
                        {{ moment(new Date()).format("DD/MM/YYYY [&nbsp;] HH:mm") }}
                    </K2Text>
                </div>
              <div class="me-2">
                <K2Text bold="true">{{lang("Post Type")}}:</K2Text>
                <K2Text :color="uiVariable.color.purple" v-if="isBroadcast"> Broadcast</K2Text>
                <K2Text :color="uiVariable.color.purple" v-else> {{ isNewsfeed? lang("Feeds"):lang(this.parentPost.PostType)}}</K2Text>
              </div>
              <div>
                <K2Text bold="true">{{lang("Teacher")}}:</K2Text>
                <K2Text :color="uiVariable.color.purple"> {{ parentPost.CONname }}</K2Text>
              </div>
            </K2Row>

        </div>
    </div>
  </K2Modal>
</template>

<script>
  import uiVariable from "../../../../config/uiVariable";
  import K2Carousel from "../../../../uiComponents/k2Carousel/k2Carousel";
  import K2Text from "../../../../uiComponents/k2Text/k2Text";
  import moment from "moment";
  import K2Row from "../../../../uiComponents/k2Row/k2Row";
  import K2Icon from "../../../../uiComponents/k2Icon/k2MAIcon";
  import K2Button from "../../../../uiComponents/k2Button/k2Button";
  import { lang } from "../../../../locale";
  import { getRole } from "@/helper/util_custom";
  import ActivityPreviewGoal from "../activityPreviewGoal";
  import K2Modal from "@/uiComponents/k2Modal/k2Modal";
  import K2Heading from "@/uiComponents/k2Heading/k2Heading";
  import K2Confirm from "@/uiComponents/k2Confirm/k2Confirm";

  export default {
    name: "activityPreview",
    props: ["passObservation", "isPublished", "passmseelctedclasses", "passSchool", "parentPost", "isBroadcast", "posttitle",
      "state", "layoutConfig","modal","approverPostNotShow","post","feedUserID"],
    components: { K2Confirm, K2Heading, K2Modal, ActivityPreviewGoal, K2Button, K2Icon, K2Row, K2Text, K2Carousel },
    data() {
      return {
        uiVariable: uiVariable,
        moment: moment,
        allStudentShow: false,
        feedItemConfig: {
          contentLabel: "",
          content2Label: "",
          content3Label: "",
          content4Label: ""
        },
        userType: "",
        isMomentPost: false,
        isBroadcastPost: false,
        isNewsfeed: false,
        selectedStudents: [],
        levelList:[],
        classList:[],
        postCategory:""
      };
    },
    watch: {
      parentPost: function(value) {
        if (value) {
          this.handleSetting();
        }
      }
    },
    created() {

    },
    mounted() {
      this.handleSetting();
      this.userType = getRole();
    },
    methods: {
      lang,
      onSlideStart(slide) {
        this.sliding = true;
      },
      handleStudentShow() {
        this.allStudentShow = !this.allStudentShow;
      },
      handleSetting() {
        this.isMomentPost = false;
        this.isBroadcastPost = false;
        this.isNewsfeed = false;
        this.postCategory = "";
        //layout setting for post type
        this.selectedStudents = this.parentPost?.studentList;
        this.levelList = this.parentPost?.levelList;
        this.classList = this.parentPost?.classList;
        switch (this.parentPost?.PostType) {
          case "Feed":
          case "Update":
            this.feedItemConfig = {
              contentLabel: lang("Intended Project Update"),
              content2Label: lang("Suggestions for Home-School Connection"),
              content3Label: lang("Language and Literacy Focus"),
              content4Label: lang("Numeracy Focus")
            };
            this.isNewsfeed = true;
            this.postCategory = lang("Newsfeed") + " :";
            break;
          case "Moment":
            if (this.parentPost.PostTagLists && this.parentPost.PostTagLists.length) {
              this.parentPost.PostTagLists.forEach(d => {
                // let studentDOB = moment(d.StudentDob, "DD/MM/YYYY");
                let age = moment.duration(moment().diff(d.StudentDob));
                let years = age.years();
                let months = age.months();
                d.age = `${years} year(s) ${months} month(s)`;
              });
            }
            this.feedItemConfig = {
              contentLabel: lang("Context"),
              content2Label: lang("Observation")
            };
            this.isMomentPost = true;
            // this.handleContentChange("", "content");
            // this.handleContentChange("", "content2");
            // this.handleContentChange("", "content3");
            // this.handleContentChange("", "content4");
            this.postCategory = lang("Moments") + " :";
            break;
          case 'Broadcast':
            this.isBroadcastPost = true;
            this.postCategory = lang("Broadcast") + " :";
            break;
          default:
            this.isMomentPost = false;
            this.isBroadcastPost = false;
            this.isNewsfeed = false;
            this.postCategory = "";
            break;
        }
      },
      checkContent(content){
        if(content){
          return content !== "undefined" && content !== "null"
        }else{
          return false
        }
      },
    }
  };
</script>